import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FiExternalLink, FiGithub, FiArrowRight } from "react-icons/fi";
import { projectsData } from "../data/projects";
import "./Portfolio.css";

const Portfolio = () => {
  const [activeFilter, setActiveFilter] = useState("All");
  const [visibleProjects, setVisibleProjects] = useState(6);

  const categories = ["All", "Web App", "Group Project", "Backend API"];

  const filteredProjects =
    activeFilter === "All"
      ? projectsData
      : projectsData.filter((project) => project.category === activeFilter);

  const displayedProjects = filteredProjects.slice(0, visibleProjects);

  const loadMore = () => {
    setVisibleProjects((prev) => prev + 3);
  };

  return (
    <section id="portfolio" className="portfolio section">
      <div className="container">
        <div className="section-header">
          <span className="section-subtitle">Portfolio</span>
          <h2 className="section-title">Featured Projects</h2>
          <p className="section-description">
            A selection of my recent work in web development and design.
          </p>
        </div>

        {/* Filter Buttons */}
        <div className="portfolio-filters">
          {categories.map((category, index) => (
            <button
              key={index}
              className={`filter-btn ${activeFilter === category ? "active" : ""}`}
              onClick={() => {
                setActiveFilter(category);
                setVisibleProjects(6);
              }}
            >
              {category}
            </button>
          ))}
        </div>

        {/* Projects Grid */}
        <div className="portfolio-grid">
          {displayedProjects.map((project, index) => (
            <div
              key={project.id}
              className="portfolio-item fade-in"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="portfolio-image">
                <img src={project.thumbnail} alt={project.title} />
                <div className="portfolio-overlay">
                  <div className="overlay-content">
                    <div className="portfolio-links">
                      <a
                        href={project.liveUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="portfolio-link"
                        aria-label="View live site"
                      >
                        <FiExternalLink />
                      </a>
                      <a
                        href={project.githubUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="portfolio-link"
                        aria-label="View source code"
                      >
                        <FiGithub />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="portfolio-content">
                <span className="portfolio-category">{project.category}</span>
                <h3 className="portfolio-title">{project.title}</h3>
                <p className="portfolio-description">
                  {project.shortDescription}
                </p>
                <div className="portfolio-tech">
                  {project.technologies.slice(0, 3).map((tech, techIndex) => (
                    <span key={techIndex} className="tech-tag">
                      {tech}
                    </span>
                  ))}
                  {project.technologies.length > 3 && (
                    <span className="tech-tag more">
                      +{project.technologies.length - 3}
                    </span>
                  )}
                </div>
                <Link to={`/project/${project.id}`} className="portfolio-btn">
                  View Case Study
                  <FiArrowRight />
                </Link>
              </div>
            </div>
          ))}
        </div>

        {/* Load More Button */}
        {visibleProjects < filteredProjects.length && (
          <div className="portfolio-load-more">
            <button className="btn btn-secondary" onClick={loadMore}>
              Load More Projects
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

export default Portfolio;
